import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BffGetListLessonsEndpoint, type Lesson as LessonApi } from 'lingo2-api-models';
import { IPagination, Lesson } from 'lingo2-models';
import { map, type Observable } from 'rxjs';

export function mapToLesson(lesson: LessonApi): Lesson {
  const constructData: Partial<Lesson> = { id: lesson.id };

  for (const key of Object.keys(lesson)) {
    const value = lesson[key];
    switch (key) {
      // dates
      case 'created_at':
      case 'archived_at':
      case 'published_at':
        constructData[key] = value ? new Date(value as number) : null;
        break;
      // Базовые поля
      default:
        constructData[key] = value;
    }
  }

  return new Lesson(constructData);
}

@Injectable({ providedIn: 'root' })
export class LessonsBffService {
  private readonly http = inject(HttpClient);
  private baseUrl = (path: string): string => `${environment.bff_url}/${path}`;

  getList(dto: BffGetListLessonsEndpoint.Body): Observable<{ list: LessonApi[]; pagination: IPagination }> {
    return this.http
      .post<BffGetListLessonsEndpoint.Response>(this.baseUrl(BffGetListLessonsEndpoint.path), dto, {
        observe: 'body',
      })
      .pipe(
        map((response) => {
          if (response.status === 'ok') {
            return {
              list: response.data.list,
              pagination: response.data.pagination,
            };
          } else {
            console.error(response.errorMessage);
            return { list: [], pagination: null };
          }
        }),
      );
  }
}
